import { Button, Col, Modal, Row, Table } from 'antd';
import { useUnit } from 'effector-react';
import { Bar, Column } from '@ant-design/charts';
import {
  $okedsModalsFilters,
  $regionsOkedsData,
  $regionsOkedsModal,
  changeOkedsModalEv,
  changeOkedsModalsFiltersEv,
  changeRegionModalEv,
  changeRegionsOkedsModalEv,
  RegionsOkedsGate,
} from '../../models/investProjectsModel/index.js';
import {
  downloadProjectsEv,
  downloadProjectsFx,
} from '../../models/overviewModel/index.js';
import { useState } from 'react';

function InvestRegionsOkedsModal() {
  const regionsOkedsModal = useUnit($regionsOkedsModal);
  const changeRegionsOkedsModal = useUnit(changeRegionsOkedsModalEv);
  const changeRegionModal = useUnit(changeRegionModalEv);
  const changeOkedsModal = useUnit(changeOkedsModalEv);
  const regionsOkedsData = useUnit($regionsOkedsData);

  const downloadProjects = useUnit(downloadProjectsEv);
  const downloadProjectsLoading = useUnit(downloadProjectsFx.pending);

  const modalFilters = useUnit($okedsModalsFilters);
  const setModalFilters = useUnit(changeOkedsModalsFiltersEv);

  const [zoomChart, setZoomChart] = useState({ chart: null, zoom: false });
  const onZoomChange = (newChart) => {
    setZoomChart((prev) => ({
      chart: newChart,
      zoom: prev.chart === newChart ? !prev.zoom : true,
    }));
  };

  const regionsKPIColumns = [
    {
      title: '№',
      key: 'regions_num',
      dataIndex: 'num',
    },
    {
      title: 'Регион',
      key: 'regions_region',
      dataIndex: 'region',
    },
    {
      title: 'KPI-1',
      key: 'regions_kpi_1',
      dataIndex: 'kpi_1',
    },
    {
      title: 'KPI-2',
      key: 'regions_kpi_2',
      dataIndex: 'kpi_2',
    },
  ];

  const okedsKPIColumns = [
    {
      title: '№',
      key: 'okeds_num',
      dataIndex: 'num',
    },
    {
      title: 'Вид деятельности',
      key: 'okeds_activity',
      dataIndex: 'activity',
    },
    {
      title: 'KPI-1',
      key: 'okeds_kpi_1',
      dataIndex: 'kpi_1',
    },
    {
      title: 'KPI-2',
      key: 'okeds_kpi_2',
      dataIndex: 'kpi_2',
    },
  ];

  const quarterKPIConfig = {
    data: regionsOkedsData?.quarter_kpi || [],
    isGroup: true,
    xField: 'quarter',
    yField: 'value',
    seriesField: 'type',
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };
  const regionBarConfig = {
    isStack: true,
    xField: 'value',
    seriesField: 'phase',
    legend: false,
    label: {
      position: 'middle',
      layout: [
        {
          type: 'interval-adjust-position',
        },
        {
          type: 'interval-hide-overlap',
        },
        {
          type: 'adjust-color',
        },
      ],
    },
  };

  return (
    <Modal
      zIndex={100}
      destroyOnClose
      open={regionsOkedsModal}
      onCancel={(e) => {
        e.stopPropagation();
        changeRegionsOkedsModal(false);
      }}
      footer={null}
      width="80vw"
      title={
        <Button
          type="primary"
          size={'middle'}
          onClick={() => downloadProjects()}
          loading={downloadProjectsLoading}
        >
          Выгрузка проектов
        </Button>
      }
    >
      <RegionsOkedsGate />
      {regionsOkedsData && (
        <Row gutter={[16, 16]}>
          <Col
            order={zoomChart.chart === 1 && zoomChart.zoom ? 2 : 1}
            lg={{ span: 12 }}
            xl={{ span: zoomChart.chart === 1 && zoomChart.zoom ? 12 : 8 }}
          >
            <Table
              pagination={false}
              rowSelection={{
                hideSelectAll: true,
                selections: true,
                selectedRowKeys: modalFilters.region_id
                  ? [modalFilters.region_id]
                  : [],
                onChange: (keys) => {
                  setModalFilters({
                    region_id: keys?.length > 0 ? keys?.at(-1) : null,
                  });
                },
              }}
              rowKey={'id'}
              columns={regionsKPIColumns}
              rowClassName="pointer"
              onRow={(record) => {
                return {
                  onClick: (e) => {
                    setModalFilters({
                      region_id: record.id,
                    });
                    changeRegionModal(record);
                  },
                };
              }}
              dataSource={regionsOkedsData.regions_kpi}
            />
          </Col>
          <Col
            lg={{ span: 24, order: 3 }}
            xl={{
              span: zoomChart.chart === 1 && zoomChart.zoom ? 24 : 8,
              order: zoomChart.chart === 1 && zoomChart.zoom ? 1 : 2,
            }}
          >
            <Column
              {...quarterKPIConfig}
              onReady={(plot) => {
                plot.on('plot:click', () => {
                  onZoomChange(1);
                });

                plot.on('axis-label:click', (evt) => {
                  console.log('Axis Label clicked:', evt);
                });
              }}
            />
          </Col>
          <Col
            lg={{ span: 12, order: 2 }}
            xl={{
              span: zoomChart.chart === 1 && zoomChart.zoom ? 12 : 8,
              order: 3,
            }}
          >
            <Table
              columns={okedsKPIColumns}
              pagination={false}
              rowClassName="pointer"
              rowKey={'id'}
              rowSelection={{
                hideSelectAll: true,
                selections: true,
                selectedRowKeys: modalFilters.activity_id
                  ? [modalFilters.activity_id]
                  : [],
                onChange: (keys) => {
                  setModalFilters({
                    activity_id: keys?.length > 0 ? keys?.at(-1) : null,
                  });
                },
              }}
              onRow={(record) => {
                return {
                  onClick: (e) => {
                    setModalFilters({
                      activity_id: record.id,
                    });
                    changeOkedsModal(record);
                  },
                };
              }}
              dataSource={regionsOkedsData.activity_kpi}
            />
          </Col>
          <Col
            order={zoomChart.chart === 3 && zoomChart.zoom ? 5 : 4}
            md={{ span: 24 }}
            lg={{ span: zoomChart.chart === 2 && zoomChart.zoom ? 24 : 12 }}
          >
            <Bar
              data={regionsOkedsData.projects_by_region}
              yField="region"
              onReady={(plot) => {
                plot.on('plot:click', () => {
                  onZoomChange(2);
                });

                plot.on('axis-label:click', (evt) => {
                  console.log('Axis Label clicked:', evt);
                });
              }}
              color={[
                'rgb(249,228,91)',
                'rgb(110, 147, 243)',
                'rgb(148,255,92)',
              ]}
              {...regionBarConfig}
            />
          </Col>
          <Col
            order={zoomChart.chart === 3 && zoomChart.zoom ? 4 : 5}
            md={{ span: 24 }}
            xl={{ span: zoomChart.chart === 3 && zoomChart.zoom ? 24 : 12 }}
          >
            <Bar
              data={regionsOkedsData.projects_by_activity}
              yField="activity"
              yAxis={{
                label: {
                  formatter: (text) => `${text.slice(0, 20)}...`,
                },
              }}
              onReady={(plot) => {
                plot.on('plot:click', () => {
                  onZoomChange(3);
                });

                plot.on('axis-label:click', (evt) => {
                  console.log('Axis Label clicked:', evt);
                });
              }}
              color={[
                'rgb(249,228,91)',
                'rgb(110, 147, 243)',
                'rgb(148,255,92)',
              ]}
              {...regionBarConfig}
            />
          </Col>
        </Row>
      )}
    </Modal>
  );
}

export default InvestRegionsOkedsModal;
